import { CalendarFilterFormVO } from '@domain/vo/calendar/CalendarFilterFormVO';
import { BusinessSizeType } from '@domain/constant/businessSize';
import { RecruitCategoryType } from '@domain/constant/recruitCategoryType';
import { LocationCode } from '@domain/constant/locationType';

export default class CalendarPcListRq {
  jobTitles?: number[];
  recruitmentTypes?: RecruitCategoryType[];
  businessSizeTypes?: BusinessSizeType[];
  locations?: number[];
  targetMonth?: string;
  keyword?: string;

  constructor(vo: CalendarFilterFormVO) {
    this.jobTitles = vo.jobTitles?.map((e) => e.code);
    this.recruitmentTypes = vo.recruitmentTypes;
    this.businessSizeTypes = vo.businessSizeTypes;
    this.locations = vo.locations?.map((e) => LocationCode[e as keyof typeof LocationCode]);
    this.targetMonth = vo.targetMonth;
    this.keyword = vo.keyword;
  }
}
